import React from 'react';
import {GardenFilterValues} from "../planning21.interfaces";
import {range} from "lodash";
import DateRow from "../rows/DateRow";

interface DateBasedPlanningProps {
  gardenFilters: GardenFilterValues;
}

const DateBasedPlanning = (props: DateBasedPlanningProps) => {

  return <>
    {range(2, 52, 2).map(weekNumber => <DateRow key={weekNumber} weekNumber={weekNumber} filters={props.gardenFilters}/>)}
  </>;
};

export default DateBasedPlanning;
